import Vue from "vue";
import _, { Dictionary } from "lodash";
import { gameStore } from "../store/game/store";
import { Card, CardCategory } from "@/store/game";
export default Vue.extend({
  computed: {
    playerSeeableCards(): Card[] {
      return gameStore.playerSeeableCards;
    },
    byCategory(): any {
        return {
            "P_A": _.filter(this.playerSeeableCards, pc => pc.category == CardCategory.Person && pc.type == "A").length,
            "P_B": _.filter(this.playerSeeableCards, pc => pc.category == CardCategory.Person && pc.type == "B").length,
            "L_A": _.filter(this.playerSeeableCards, pc => pc.category == CardCategory.Location && pc.type == "A").length,
            "L_B": _.filter(this.playerSeeableCards, pc => pc.category == CardCategory.Location && pc.type == "B").length,
            "W_A": _.filter(this.playerSeeableCards, pc => pc.category == CardCategory.Weapon && pc.type == "A").length,
            "W_B": _.filter(this.playerSeeableCards, pc => pc.category == CardCategory.Weapon && pc.type == "B").length,
        }; 
    },
    byColor(): Dictionary<number> {
      const bc = _.countBy(this.playerSeeableCards, pc => pc.number);
      return bc;
    }
  }
});